import styled, { createGlobalStyle } from 'styled-components';
import { withOpacity, donedealBreakpoints } from 'styled-system';
import { ModalStyledProps } from './Modal.typed';
const { media } = donedealBreakpoints;

// Overwrites "ReactModal__Overlay"
const GlobalOverlayStyle = createGlobalStyle<
  {
    modalClassName: string;
  } & ModalStyledProps
>`
  .react-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: ${({ theme, zIndex }) => zIndex || theme.donedeal.zIndices.MODAL};
    transition: ${({ openTimeoutMS }) => `all ${openTimeoutMS}ms ease-in-out`};

    &.ReactModal__Overlay--after-open {
      opacity: 1;
      background-color: ${({ theme }) =>
        withOpacity(theme.donedeal.colors.GREY_DARKER, 0.8)};
    }

    &.ReactModal__Overlay--before-close {
      opacity: 0;
      background-color: none;
    }
  }

  ${({
    modalClassName,
    openTimeoutMS,
    onScreenTransform,
    offScreenTransform,
    top,
    right,
    bottom,
    left,
    theme,
    width,
    height,
    borderRadius,
    padding,
    topMedium,
    rightMedium,
    bottomMedium,
    leftMedium,
    widthMedium,
    heightMedium,
    borderRadiusMedium,
    paddingMedium,
    offScreenTransformMedium,
    topLarge,
    rightLarge,
    bottomLarge,
    leftLarge,
    widthLarge,
    heightLarge,
    borderRadiusLarge,
    paddingLarge,
    offScreenTransformLarge,
    onScreenTransformMedium,
    onScreenTransformLarge,
    closeTimeoutMS,
  }) => {
    return `
    .base-${modalClassName} {
      background-color: ${theme.donedeal.colors.WHITE};
      transform: ${offScreenTransform};
      position: fixed;
      width: ${width};
      height: ${height};
      top: ${top};
      right: ${right};
      bottom: ${bottom};
      left: ${left};
      border-radius: ${borderRadius};
      padding: ${padding};

      ${media.medium} {
        top: ${topMedium};
        right: ${rightMedium};
        bottom: ${bottomMedium};
        left: ${leftMedium};
        width: ${widthMedium};
        height: ${heightMedium};
        border-radius: ${borderRadiusMedium};
        padding: ${paddingMedium};
        transform: ${offScreenTransformMedium};
      }

      ${media.large} {
        top: ${topLarge};
        right: ${rightLarge};
        bottom: ${bottomLarge};
        left: ${leftLarge};
        width: ${widthLarge};
        height: ${heightLarge};
        border-radius: ${borderRadiusLarge};
        padding: ${paddingLarge};
        transform: ${offScreenTransformLarge};
      }
    }
    
    .afterOpen-${modalClassName} {
      transition: ${openTimeoutMS ? `all ${openTimeoutMS}ms ease-out` : ''};
      transform: ${onScreenTransform};

      ${media.medium}{
        transform: ${onScreenTransformMedium};
      }

      ${media.large}{
        transform: ${onScreenTransformLarge};
      }
    }
    
    .beforeClose-${modalClassName} {
      transition: ${closeTimeoutMS ? `all ${closeTimeoutMS}ms ease-in` : ''};
      // On close, the modal returns to its initial position
      transform: ${offScreenTransform};

      ${media.medium}{
        transform: ${offScreenTransformMedium};
      }

      ${media.large}{
        transform: ${offScreenTransformMedium};
      }
    }
    `;
  }}
`;

const ModalContent = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const ScrollableBody = styled.div`
  flex-grow: 1;
  // Allow the body to scroll if content overflows - prefer 'auto' over 'scroll' to avoid scrollbar showing when not needed.
  overflow-y: auto;
`;

export { GlobalOverlayStyle, ModalContent, ScrollableBody };
